import { render, staticRenderFns } from "./tablec1.vue?vue&type=template&id=0ad4254c"
import script from "./tablec1.vue?vue&type=script&lang=js"
export * from "./tablec1.vue?vue&type=script&lang=js"
import style0 from "./tablec1.vue?vue&type=style&index=0&id=0ad4254c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports